import { PersistStorage, recoilPersist } from "recoil-persist";

interface Props {
  key: string;
  storage: PersistStorage;
}

export const createPersistAtom = ({ key, storage }: Props) =>
  recoilPersist({ key, storage }).persistAtom;
